import BasicTextField from './BasicTextField';
import { BasicTextFieldProps } from './BasicTextField.types';

function NumberInputField({ sx, inputProps, ...props }: BasicTextFieldProps) {
  return (
    <BasicTextField
      type="number"
      inputProps={{ step: 0.001, ...inputProps }}
      sx={{
        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
          { WebkitAppearance: 'none', margin: 0 },
        ...sx,
      }}
      {...props}
    />
  );
}
export default NumberInputField;
